// extracted by mini-css-extract-plugin
export default {"handle":"Handle_handle__EBozE"};